// frontend/src/services/authService.js (Updated with better error handling)
import api from "../config/api";
import Cookies from "js-cookie";

class AuthService {
  async login(username, password) {
    try {
      console.log("AuthService: Attempting login for:", username);

      const response = await api.post("/auth/login", {
        username,
        password,
      });

      console.log("AuthService: Login response:", response.data);

      if (response.data.success) {
        // Store token and user data in cookies
        Cookies.set("academy_token", response.data.token, { expires: 7 });
        Cookies.set("academy_user", JSON.stringify(response.data.user), {
          expires: 7,
        });

        console.log("AuthService: Login successful, tokens stored");

        return {
          success: true,
          user: response.data.user,
        };
      }

      console.log("AuthService: Login failed:", response.data.message);
      return {
        success: false,
        error: response.data.message || "Login failed",
      };
    } catch (error) {
      console.error("AuthService: Login error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const statusCode = error.response.status;
        const errorMessage = error.response.data?.message || "Login failed";

        console.error("AuthService: Server error:", statusCode, errorMessage);

        if (statusCode === 401) {
          return {
            success: false,
            error: "Invalid email or password",
          };
        } else if (statusCode === 403) {
          return {
            success: false,
            error:
              "Access denied - You are not authorized to access this application",
          };
        } else if (statusCode === 500) {
          return {
            success: false,
            error: "Server error - Please try again later",
          };
        } else {
          return {
            success: false,
            error: errorMessage,
          };
        }
      } else if (error.request) {
        // Network error
        console.error("AuthService: Network error:", error.request);
        return {
          success: false,
          error: "Network error - Please check your connection and try again",
        };
      } else {
        // Other error
        console.error("AuthService: Unknown error:", error.message);
        return {
          success: false,
          error: "An unexpected error occurred",
        };
      }
    }
  }

  async verifyToken() {
    try {
      const response = await api.get("/auth/verify");
      return {
        success: true,
        user: response.data.user,
      };
    } catch (error) {
      console.error("AuthService: Token verification failed:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Token verification failed",
      };
    }
  }

  logout() {
    console.log("AuthService: Logging out");
    Cookies.remove("academy_token");
    Cookies.remove("academy_user");
  }

  getStoredUser() {
    try {
      const userData = Cookies.get("academy_user");
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error("Error parsing stored user data:", error);
      return null;
    }
  }

  isAuthenticated() {
    return !!Cookies.get("academy_token");
  }
}

export default new AuthService();
